import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DraggableModalWrapperComponent } from '../../../../../../shared/components/modal/draggable-modal-wrapper/draggable-modal-wrapper.component';

@Component({
    selector: 'app-fcc-licensing-info-consent-dialog',
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        DraggableModalWrapperComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: `./fcc-licensing-info-consent-dialog.component.html`,
})
export class FccLicensingInfoConsentDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<FccLicensingInfoConsentDialogComponent>,
    ) {}

    declineToSaveInformation(): void {
        this.dialogRef.close(false);
    }

    agreeToSaveInformation(): void {
        this.dialogRef.close(true);
    }
}
